import { html, LitElement, unsafeCSS } from 'lit';
import { customElement } from 'lit/decorators.js';
import '../../ui-sprite-svg/ui-sprite-svg';
import iconStyle from './ui-apple-store-icon.css?inline';

const CName = 'ui-apple-store-icon';

@customElement(CName)
export class UIAppleStoreIcon extends LitElement {
  static readonly styles = unsafeCSS(iconStyle);

  render() {
    return html`<ui-sprite-svg class="icon" .iconID=${'apple-store-icon'}></ui-sprite-svg>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [CName]: UIAppleStoreIcon;
  }
}
